"use client";

import { useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../../../shadcnui";
import { formatCurrency, formatDate } from "../../../components/utils";
import { StripeInvoiceInterface } from "../../data/stripe-invoice.interface";
import { InvoiceDetails } from "../details/InvoiceDetails";
import { InvoiceStatusBadge } from "../widgets/InvoiceStatusBadge";

type InvoicesListProps = {
  invoices: StripeInvoiceInterface[];
  onInvoicesChange: () => void;
};

export function InvoicesList({ invoices, onInvoicesChange }: InvoicesListProps) {
  const [selectedInvoice, setSelectedInvoice] = useState<StripeInvoiceInterface | null>(null);

  const handleRowClick = (invoice: StripeInvoiceInterface) => {
    setSelectedInvoice(invoice);
  };

  const getInvoiceNumber = (invoice: StripeInvoiceInterface): string => {
    if (invoice.stripeInvoiceNumber) {
      return invoice.stripeInvoiceNumber;
    }
    // Use last 8 characters of stripeInvoiceId as fallback
    return invoice.stripeInvoiceId.slice(-8);
  };

  return (
    <>
      <div className="border rounded-lg overflow-clip">
        <Table>
          <TableHeader className="bg-muted">
            <TableRow>
              <TableHead>Invoice #</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-end">Amount</TableHead>
              <TableHead>Period</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {invoices.map((invoice) => {
              const invoiceNumber = getInvoiceNumber(invoice);
              const date = formatDate(invoice.periodStart);
              const amount = formatCurrency(invoice.total, invoice.currency);
              const period = `${formatDate(invoice.periodStart)} - ${formatDate(invoice.periodEnd)}`;

              return (
                <TableRow
                  key={invoice.id}
                  onClick={() => handleRowClick(invoice)}
                  className="cursor-pointer hover:bg-muted/50"
                >
                  <TableCell className="font-medium">{invoiceNumber}</TableCell>
                  <TableCell className="text-muted-foreground text-xs">{date}</TableCell>
                  <TableCell>
                    <InvoiceStatusBadge status={invoice.status} />
                  </TableCell>
                  <TableCell className="text-end font-medium">{amount}</TableCell>
                  <TableCell className="text-muted-foreground text-xs">{period}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>

      {/* Invoice Details Dialog */}
      {selectedInvoice && (
        <InvoiceDetails
          invoice={selectedInvoice}
          open={!!selectedInvoice}
          onOpenChange={(open) => !open && setSelectedInvoice(null)}
          onInvoiceChange={() => {
            onInvoicesChange();
            setSelectedInvoice(null);
          }}
        />
      )}
    </>
  );
}
